// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__1p9vL"};